import { Switch } from '@contentful/f36-components';
import { ChangeEvent } from 'react';
import { TestIds } from '../fixtures/constants';

interface ProductSelectorModeSwitchProps {
  useCsvProductInput: boolean;
  onChangeUseCsvProductInput: (value: boolean) => void;
}

export const ProductSelectorModeSwitch = (props: ProductSelectorModeSwitchProps): React.JSX.Element => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChangeUseCsvProductInput(e.currentTarget.checked);
  };

  return (
    <Switch data-test-id={TestIds.PRODUCTS_MODE_TOGGLE} isChecked={props.useCsvProductInput} onChange={handleChange}>
      Bulk product input
    </Switch>
  );
};
